module.exports = __webpack_public_path__ + "static/media/donkey.9d014807.png";